export const API_URL = /localhost/.test(location.href) ? 'http://localhost:3000' : 'https://api.cryptery.org'
export const IS_MOBILE = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) < 800